import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from '../../ActivitiesRegistrationHeader';

import { formatDocument, formatPhone } from 'helpers/formatters';

const days = [
  { value: 1, label: 'Segunda-feira' },
  { value: 2, label: 'Terça-feira' },
  { value: 3, label: 'Quarta-feira' },
  { value: 4, label: 'Quinta-feira' },
  { value: 5, label: 'Sexta-feira' },
  { value: 6, label: 'Sábado' },
  { value: 7, label: 'Domingo' }
];

export default function ClientUpdate({ activityData, lastRegister, newRegister }) {
  const { selects } = useSelector(state => state.filters);

  const services = selects?.find(service => service?.id == 'services')?.options;

  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader activityData={activityData} />
        <Grid container style={{ marginTop: 10 }}>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Registro Anterior</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(lastRegister).includes('name') && (
                <Row>
                  <Typography color='primary'>
                    <b>Nome</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.name || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('email') && (
                <Row>
                  <Typography color='primary'>
                    <b>Email</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.email || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('documentId') && (
                <Row>
                  <Typography color='primary'>
                    <b>CPF/CNPJ</b>
                  </Typography>
                  <Typography color='textSecondary'>{formatDocument(lastRegister?.documentId) || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('phones') && (
                <Row>
                  <Typography color='primary'>
                    <b>Telefone</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.phones?.length > 0 ? formatPhone(lastRegister?.phones[0]) : '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('dateOfBirth') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data de Nascimento</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.dateOfBirth, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('comments') && (
                <Row>
                  <Typography color='primary'>
                    <b>Observação</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.comments || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('postalCode') && (
                <Row>
                  <Typography color='primary'>
                    <b>CEP</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.postalCode || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('street') && (
                <Row>
                  <Typography color='primary'>
                    <b>Endereço</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.street || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('streetNumber') && (
                <Row>
                  <Typography color='primary'>
                    <b>Número</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.streetNumber || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('streetComplement') && (
                <Row>
                  <Typography color='primary'>
                    <b>Complemento</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.streetComplement || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('district') && (
                <Row>
                  <Typography color='primary'>
                    <b>Bairro</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.district || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('city') && (
                <Row>
                  <Typography color='primary'>
                    <b>Cidade</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.city || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('state') && (
                <Row>
                  <Typography color='primary'>
                    <b>Estado</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.state || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('weekDaysPermission') && (
                <Row>
                  <Typography color='primary'>
                    <b>Dias que o cliente pode usar</b>
                  </Typography>
                  <Typography color='textSecondary'>
                    {days?.filter(day => JSON.parse(lastRegister?.weekDaysPermission)?.sort((a, b) => a - b)?.includes(day?.value))?.map(day => day?.label).join(', ') || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('startTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Hora inicial</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.startTime, 'HH:mm:ss').format('HH:mm')}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('endTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Hora final</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(lastRegister?.endTime, 'HH:mm:ss').format('HH:mm')}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('vacancies') && (
                <Row>
                  <Typography color='primary'>
                    <b>Vagas disponíveis</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.vacancies || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('restrictionTypePrice') && (
                <Row>
                  <Typography color='primary'>
                    <b>Qual tabela cobrar caso esteja fora da restrição</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.restrictionTypePrice || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('services') && (
                <Row>
                  <Typography color='primary'>
                    <b>Serviços</b>
                  </Typography>
                  <Typography color='textSecondary'>{services?.filter(service => lastRegister?.services?.includes(+service?.serviceId))?.map(service => service?.description)?.join(', ') || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('typePrices') && (
                <Row>
                  <Typography color='primary'>
                    <b>Automatizações</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.typePrices?.join(', ') || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('typePricesLink') && (
                <Row>
                  <Typography color='primary'>
                    <b>Tabelas vinculadas</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.typePricesLink?.join(', ') || '--'}</Typography>
                </Row>
              )}
              {Object.keys(lastRegister).includes('importedClients') && (
                <Row>
                  <Typography color='primary'>
                    <b>IDs dos clientes importados</b>
                  </Typography>
                  <Typography color='textSecondary'>{lastRegister?.importedClients?.join(', ') || '--'}</Typography>
                </Row>
              )}
            </Grid>
          </Grid>
          <Grid xs={12} style={{ padding: 5 }}>
            <Typography color='primary' style={{ marginBottom: 5, borderBottom: '1px solid #E4E7EA' }}>
              <b>Novo Registro</b>
            </Typography>
            <Grid style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
              {Object.keys(newRegister).includes('name') && (
                <Row>
                  <Typography color='primary'>
                    <b>Nome</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.name || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('email') && (
                <Row>
                  <Typography color='primary'>
                    <b>Email</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.email || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('documentId') && (
                <Row>
                  <Typography color='primary'>
                    <b>CPF/CNPJ</b>
                  </Typography>
                  <Typography color='textSecondary'>{formatDocument(newRegister?.documentId) || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('phones') && (
                <Row>
                  <Typography color='primary'>
                    <b>Telefone</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.phones?.length > 0 ? formatPhone(newRegister?.phones[0]) : '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('dateOfBirth') && (
                <Row>
                  <Typography color='primary'>
                    <b>Data de Nascimento</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(newRegister?.dateOfBirth, 'YYYY-MM-DD').format('DD/MM/YYYY')}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('comments') && (
                <Row>
                  <Typography color='primary'>
                    <b>Observação</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.comments || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('postalCode') && (
                <Row>
                  <Typography color='primary'>
                    <b>CEP</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.postalCode || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('street') && (
                <Row>
                  <Typography color='primary'>
                    <b>Endereço</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.street || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('streetNumber') && (
                <Row>
                  <Typography color='primary'>
                    <b>Número</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.streetNumber || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('streetComplement') && (
                <Row>
                  <Typography color='primary'>
                    <b>Complemento</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.streetComplement || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('district') && (
                <Row>
                  <Typography color='primary'>
                    <b>Bairro</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.district || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('city') && (
                <Row>
                  <Typography color='primary'>
                    <b>Cidade</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.city || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('state') && (
                <Row>
                  <Typography color='primary'>
                    <b>Estado</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.state || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('weekDaysPermission') && (
                <Row>
                  <Typography color='primary'>
                    <b>Dias que o cliente pode usar</b>
                  </Typography>
                  <Typography color='textSecondary'>
                    {days?.filter(day => JSON.parse(newRegister?.weekDaysPermission)?.sort((a, b) => a - b)?.includes(day?.value))?.map(day => day?.label).join(', ') || '--'}
                  </Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('startTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Hora inicial</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(newRegister?.startTime, 'HH:mm:ss').format('HH:mm')}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('endTime') && (
                <Row>
                  <Typography color='primary'>
                    <b>Hora final</b>
                  </Typography>
                  <Typography color='textSecondary'>{moment(newRegister?.endTime, 'HH:mm:ss').format('HH:mm')}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('vacancies') && (
                <Row>
                  <Typography color='primary'>
                    <b>Vagas disponíveis</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.vacancies || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('restrictionTypePrice') && (
                <Row>
                  <Typography color='primary'>
                    <b>Qual tabela cobrar caso esteja fora da restrição</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.restrictionTypePrice || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('services') && (
                <Row>
                  <Typography color='primary'>
                    <b>Serviços</b>
                  </Typography>
                  <Typography color='textSecondary'>{services?.filter(service => newRegister?.services?.includes(+service?.serviceId))?.map(service => service?.description)?.join(', ') || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('typePrices') && (
                <Row>
                  <Typography color='primary'>
                    <b>Automatizações</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.typePrices?.join(', ') || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('typePricesLink') && (
                <Row>
                  <Typography color='primary'>
                    <b>Tabelas vinculadas</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.typePricesLink?.join(', ') || '--'}</Typography>
                </Row>
              )}
              {Object.keys(newRegister).includes('importedClients') && (
                <Row>
                  <Typography color='primary'>
                    <b>IDs dos clientes importados</b>
                  </Typography>
                  <Typography color='textSecondary'>{newRegister?.importedClients?.join(', ') || '--'}</Typography>
                </Row>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}